import React,{ Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm, change} from "redux-form";
import {  Row, Col } from "reactstrap";
import { getSettings, updateSettings, getThumbprint } from "../../actions/actionSettings";
import LoadingSpinner from "../../components/LoadingSpinner/index";
import { NotificationManager } from "react-notifications";
import Proptypes from "prop-types";
import {number, positive_float, renderToggle, renderPass, renderField, renderTextArea, renderPassTextArea, required, json, shouldEnd, renderSelectField, copyToClipboard} from "../../utils/formValidations";
import TooltipComponent from "./TooltipComponent";
import {withTranslation} from "react-i18next";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSliders } from '@fortawesome/pro-light-svg-icons/faSliders';
import PageHeader from "../../components/Header/PageHeader";
import { FormFooter, Groups, Group, FormField, TabList, Button } from "../../components/Form/Form";
import { DefaultBackground } from "../../components/DefaultBackground/DefaultBackground";
import { downloadBlob } from "../../utils/helpers";
import { faCloudArrowDown } from "@fortawesome/pro-light-svg-icons/faCloudArrowDown";
import { faCopy } from "@fortawesome/pro-light-svg-icons/faCopy";

function titleCase(string)
{
    if (string === "web_filter"){
        return "Web Filter"
    }
    else {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

}

const shouldEndMp4 = shouldEnd('.mp4');

class Settings extends Component{
    constructor(props) {
        super(props);        
        this.state = {
            pages: 1,
            settingId: null,
        };

        this.initializeForm = this.initializeForm.bind(this);
        this.submitSettings = this.submitSettings.bind(this);
        this.handleUpdateSuccess = this.handleUpdateSuccess.bind(this);
        this.handleUpdateError = this.handleUpdateError.bind(this);
        this.updateSettings = this.updateSettings.bind(this);
        this.copyThumbprint = this.copyThumbprint.bind(this);

    }

    componentDidMount(){
        this.updateSettings();
    }

    updateSettings() {
        this.props.getSettings()
            .then(() => {
                this.initializeForm();
            });
    }

    initializeForm(){
        const {settings} = this.props;
        if(settings){
            settings.map((setting) => {
                let value = setting.value;
                if (setting.value_type === 'bool') {
                    value = setting.value === 'true';
                }
                this.props.dispatch(change('settingsForm', setting.setting_id, value));
            });
        }
    }

    submitSettings(formValues) {
        let initialValues = {};
        const {settings} = this.props;
        // create array of setting id: setting value to make comparing with form values easier
        for (let set in settings){
            if (settings.hasOwnProperty(set))
                initialValues[settings[set].setting_id] = settings[set].value
        }
        //redux doesnt send empty strings...check for non existant form value to allow empty strings
        for (let setting in initialValues){
            if (initialValues.hasOwnProperty(setting)) {
                if (!formValues.hasOwnProperty(setting)) {
                    if (initialValues[setting] !== "") {
                        let settingsObj = {
                            "setting_id": setting,
                            "value": ''
                        };
                        this.props.updateSettings(settingsObj)
                            .then(() => this.handleUpdateSuccess())
                            .catch(() => this.handleUpdateError())
                    }
                }
            }
        }
        for (let setting in formValues){
            if (formValues.hasOwnProperty(setting)) {
                if (formValues[setting] !== initialValues[setting]) {
                    //adding check for boolean values being different than initial value...had caused all booleans to be sent
                    if (typeof formValues[setting] === "boolean"){
                        if (formValues[setting].toString() !== initialValues[setting]) {
                            let settingsObj = {
                                "setting_id": setting,
                                "value": formValues[setting]
                            };
                            this.props.updateSettings(settingsObj)
                                .then(() => this.handleUpdateSuccess())
                                .catch(() => this.handleUpdateError())
                        }
                    } else {
                        let settingsObj = {
                            "setting_id": setting,
                            "value": formValues[setting]
                        };
                        this.props.updateSettings(settingsObj)
                            .then(() => this.handleUpdateSuccess())
                            .catch(() => this.handleUpdateError())
                    }
                }
            }
        }

    }

    handleUpdateSuccess(){
        const {errorMessage, t} = this.props;
        if(errorMessage){
            NotificationManager.error(errorMessage, t("settings.Update Settings"), 3000);
        }
        else {
            NotificationManager.success(t("settings.Setting Updated"), t("settings.Setting Updated Successfully"));
            this.props.getSettings()
                .then(() => {
                    this.initializeForm();
                });
        }
    }

    handleUpdateError(){
        const {updateSettingsError, t} = this.props;
        if(updateSettingsError){
            NotificationManager.error(updateSettingsError,t("settings.Update Settings"), 3000);
        }
    }

    async copyThumbprint() {
        const { response } = await this.props.getThumbprint()
        if (response?.thumbprint) {
            copyToClipboard(response.thumbprint)
        }
    }


    render(){
        if (this.props.getSettingsLoading){
            return (<div> <LoadingSpinner /></div>);
        }
        const {handleSubmit, settings, pristine, submitting, t, formValues} = this.props;
        let categories = {};
        //separate settings by category
        JSON.parse(JSON.stringify(settings)).map((setting) => {
            categories[setting.category] = {...categories[setting.category], [setting.name]: setting};
        });

        const updateSiteApi = (event) => {
            const apiUrl = settings.find(el => el.name === 'google_recaptcha_api_url')
            switch (event.target.value) {
                case 'turnstile':
                    this.props.dispatch(change('settingsForm', apiUrl.setting_id, 'https://challenges.cloudflare.com/turnstile/v0/siteverify'));
                    break;
                case 'google':
                    this.props.dispatch(change('settingsForm', apiUrl.setting_id, 'https://www.google.com/recaptcha/api/siteverify'));
                    break;
                case 'hcaptcha':
                    this.props.dispatch(change('settingsForm', apiUrl.setting_id, 'https://hcaptcha.com/siteverify'));
                    break;
            }
        }
    

        let settingFields = [];
        for (let category in categories) {
            if (categories.hasOwnProperty(category))
            {
                let fields = [];
                for (let setting in categories[category]) {
                    if (categories[category].hasOwnProperty(setting)) {
                        let field = categories[category][setting];
                        // ensures String and string match
                        let type = field.value_type.toLowerCase();
                        let field_name = field.name.toLowerCase();

                        if (type === "json"){

                            field.value = JSON.stringify(JSON.parse(field.value),null,2);

                            for (let set in settings){
                                if (settings.hasOwnProperty(set))
                                    if (settings[set].setting_id === field.setting_id)
                                    {
                                        settings[set].value = field.value;
                                    }
                            }
                        }
                        const addField = () => {
                            //Name is more specific so put it at the top.
                            if (field_name === 'launcher_background_url') {
                                return <Field
                                    type="text"
                                    name={field.setting_id}
                                    id={field.setting_id}
                                    component={renderField}
                                    help={"kb-7-" + field_name}
                                    helpExtra={<DefaultBackground current={(formValues && formValues[field.setting_id]) || null} onClick={(item) => this.props.change(field.setting_id, item)} />}
                                    placeholder={field.value}
                                />
                            }
                            if (field_name === 'session_recording_upload_location') {
                                return <Field
                                    type="text"
                                    name={field.setting_id}
                                    id={field.setting_id}
                                    component={renderField}
                                    validate={shouldEndMp4}
                                    help={"kb-7-" + field_name}
                                    placeholder={field.value}
                                />
                            }
                            if (field_name === 'captcha_selection') {
                                return <Field
                                    type="text"
                                    name={field.setting_id}
                                    id={field.setting_id}
                                    component={renderSelectField}
                                    onChange={updateSiteApi}
                                    placeholder={field.value}
                                >
                                    <option value='google'>Google reCAPTCHA v2</option>
                                    <option value='turnstile'>Cloudflare Turnstile</option>
                                    <option value='hcaptcha'>hCaptcha</option>

                                </Field>
                            }
                            if (field_name === 'rdp_signer_cert') {
                                return <React.Fragment><Field
                                    type="textarea"
                                    name={field.setting_id}
                                    id={field.setting_id}
                                    component={renderTextArea}
                                    help={"kb-7-" + field_name}
                                    placeholder={field.value}
                                />
                                <div className="tw-flex tw-gap-2">
                                    <Button className="tw-mt-2" icon={<FontAwesomeIcon icon={faCloudArrowDown} />} type="button" section="buttons" name="download" onClick={() => downloadBlob(field.value, 'rdp_public_signing_certificate.cer')}></Button>
                                    <Button color="tw-bg-emerald-600" className="tw-mt-2" icon={<FontAwesomeIcon icon={faCopy} />} type="button" section="buttons" name="copy-sha1-thumbprint" onClick={this.copyThumbprint}></Button>
                                </div>
                                </React.Fragment>
                            }

                            if (type === 'bool') {
                                return <Field
                                    name={field.setting_id}
                                    id={field.setting_id}
                                    type="checkbox"
                                    checked={field.value === 'true'}
                                    component={renderToggle}
                                    help={"kb-7-" + field_name}
                                    placeholder={field.value}
                                />
                            }
                            if (type === 'string') {
                                return <Field
                                    type="text"
                                    name={field.setting_id}
                                    id={field.setting_id}
                                    component={renderField}
                                    help={"kb-7-" + field_name}
                                    placeholder={field.value}
                                />
                            }
                            if (type === 'password') {
                                return <Field
                                    type="password"
                                    name={field.setting_id}
                                    id={field.setting_id}
                                    component={renderPass}
                                    help={"kb-7-" + field_name}
                                    placeholder={field.value}
                                />
                            }
                            if (type === 'multiline_string') {
                                return <Field
                                    type="textarea"
                                    name={field.setting_id}
                                    id={field.setting_id}
                                    component={renderTextArea}
                                    help={"kb-7-" + field_name}
                                    placeholder={field.value}
                                />
                            }
                            if (type === 'int') {
                                return <Field
                                    name={field.setting_id}
                                    id={field.setting_id}
                                    type="number"
                                    component={renderField}
                                    validate={number} required
                                    help={"kb-7-" + field_name}
                                    placeholder={field.value}
                                />
                            }
                            if (type === 'float') {
                                return <Field
                                    name={field.setting_id}
                                    id={field.setting_id}
                                    type="text"
                                    component={renderField}
                                    validate={[positive_float]} required
                                    help={"kb-7-" + field_name}
                                    placeholder={field.value}
                                />
                            }
                            if (type === 'json_pass') {
                                return <Field
                                    name={field.setting_id}
                                    id={field.setting_id}
                                    type = "textarea"
                                    component={renderPassTextArea}
                                    validate={[required, json]} required
                                    help={"kb-7-" + field_name}
                                    placeholder={field.value}
                                />
                            }
                            if (type === 'json') {
                                return <Field
                                    name={field.setting_id}
                                    id={field.setting_id}
                                    type="textarea"
                                    component={renderTextArea}
                                    validate={[required, json]} required
                                    help={"kb-7-" + field_name}
                                    placeholder={field.value}
                                />
                            }
                        }
                        fields.push(
                            <FormField 
                                key={field.setting_id}
                                resetSection={true}
                                label={'settings.' + field.name}
                                /* 
                                KASM-4602 Removed until system is more reliable

                                additional={field.services_restart ? 
                                    <span className="tw-inline-block tw-text-xs text-muted-more">
                                        {t('settings.requires-restart')}: <span className={'tw-font-bold tw-text-pink-700 dark:tw-text-pink-500/70'}>{field.services_restart}</span>
                                    </span> : ''}
                                */
                                >
                                {addField()}
                            </FormField>
                        );
                    }
                }
                // Finally wrap all fields in category with border and title
                settingFields.push(<Group key={category} section="settings" title={category} description={category + '-description'}>{fields}</Group>);
            }
        }

        return (
            <div className="settings">
                <PageHeader location={this.props.location} routes={typeof newRoutes !== 'undefined' ? newRoutes : null} help="kb-7-0" title={t('settings.settings')} icon={<FontAwesomeIcon icon={faSliders} />} />
                <Row>
                    <Col sm={{ size: 10, offset: 1 }}>
                        <TabList tabList={[{ name: 'buttons.Edit', key: 'form'}]} currentTab="form" />
                        <Groups onSubmit={handleSubmit(this.submitSettings)} section="settings">
                            {settingFields && settingFields}
                            <FormFooter cancelButton={' '} />
                        </Groups>
                        
                    </Col>
                </Row>
            </div>
        );}

}

Settings.propTypes = {
    getSettings: Proptypes.func.isRequired,
    settings: Proptypes.array,
    updateSettings: Proptypes.func.isRequired,
    history: Proptypes.object.isRequired,
    getSettingsLoading: Proptypes.bool,
};

let SettingsForms =  connect(state => ({
    settings: state.settings.settings || [],
    getSettingsLoading: state.settings.getSettingsLoading || false,
    errorMessage: state.settings.errorMessage || null,
    updateSettingsError: state.settings.updateSettingsError || null,
    formValues: state.form && state.form.settingsForm && state.form.settingsForm.values ? state.form.settingsForm.values : null,
}),
dispatch => ({
    getSettings: () => dispatch(getSettings()),
    getThumbprint: () => dispatch(getThumbprint()),
    updateSettings: (data) => dispatch(updateSettings(data))
}))(Settings);

const SettingsTranslated = withTranslation('common')(SettingsForms)

export default reduxForm({
    form: "settingsForm",
})(SettingsTranslated);